import * as Dialog from '@radix-ui/react-dialog'
import * as commonStyles from '../../styles/common.css.ts'
import CloseIcon from '../icons/close-icon.svg?react'
import OnboardingLogos from '../icons/onboarding-logos.svg?react'
import * as styles from './onboarding-modal.css.ts'

type OnboardingModalProps = {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function OnboardingModal({ isOpen, setIsOpen }: OnboardingModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.alertDialogOverlay} />
        <Dialog.Content className={styles.alertDialogContent} onOpenAutoFocus={event => event.preventDefault()}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <div className={styles.headerContainer}>
              <Dialog.Title className={styles.welcome}>Welcome! 👋</Dialog.Title>
              <Dialog.Close aria-label="Close onboarding dialog">
                <CloseIcon className={styles.closeIcon} />
              </Dialog.Close>
            </div>

            <Dialog.Description asChild>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <h1 className={styles.mainHeading}>Connect your repository and upload a scan</h1>
                <p className={styles.paragraph}>
                  Once a repository is connected, upload a SARIF from your supported SAST or DAST tool to get in-depth
                  triage analysis and fixes for findings.{' '}
                  <a
                    href="https://docs.pixee.ai/code-scanning-tools/overview"
                    target="_blank"
                    className={commonStyles.link}
                  >
                    Learn more
                  </a>{' '}
                  about integrating with supported tools.
                </p>
              </div>
            </Dialog.Description>
          </div>
          <OnboardingLogos />
          <div className={styles.onboardingDialogFooter}>
            <p className={styles.additionalToolIntegrations}>
              Additional tool integrations are in the works; stay tuned!
            </p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
